import { ChartGantt, Waypoints, Download, CirclePlus } from 'lucide-react';

import { ViewMode } from '..';
import { TrackingEvents } from '@/analytics/events';
import { trackCustomEvent } from '@/analytics/Mixpanel';
import { BackButton } from '@/components/atoms/BackButton';
import { Button } from '@/components/atoms/new-button';
import Pagination, { PaginationProps } from '@/components/organisms/Pagination';
import DataViewToolbar from '@/screens/Chronos/CaseEditor/DataView/components/TableToolbar';

interface ChronologyTableToolbarProps {
  chronologyTitle: string;
  handleBack: () => void;
  openModal: () => void;
  openDownloadModal: () => void;
  goToPage: (value: number) => void;
  viewMode: ViewMode;
  onViewModeChange: (mode: ViewMode) => void;
}

const ChronologyTableToolbar = ({
  chronologyTitle,
  handleBack,
  openModal,
  openDownloadModal,
  canGetPrevPage,
  canGetNextPage,
  prevPage,
  nextPage,
  currentPage,
  noOfPages,
  goToPage,
  viewMode,
  onViewModeChange,
}: ChronologyTableToolbarProps & PaginationProps) => {
  return (
    <DataViewToolbar
      titleSection={
        <div className="flex items-center gap-4">
          <BackButton onClick={handleBack} />
          <div className="font-semibold text-blue-500">{chronologyTitle}</div>
        </div>
      }
      actionButtons={
        viewMode !== ViewMode.Visual ? (
          <>
            <Button onClick={openModal} className="h-8 rounded-sm text-xs" variant="secondary">
              <CirclePlus className="h-3 w-3" />
              Add Fact
            </Button>
            <Button onClick={openDownloadModal} className="h-8 rounded-sm text-xs" variant="secondary">
              <Download className="h-3 w-3" />
              Download
            </Button>
          </>
        ) : null
      }
      inlineSearchBar={
        <div className="flex h-8 rounded border bg-white shadow">
          <button
            onClick={() => onViewModeChange(ViewMode.Table)}
            className={`flex items-center gap-1 rounded-l px-3 py-2 text-xs font-medium transition-colors duration-200 ${
              viewMode === ViewMode.Table ? 'bg-blue-500 text-white' : 'bg-white text-gray-600 hover:bg-gray-50'
            }`}
            title="Table View"
          >
            <ChartGantt className="h-4 w-4" />
            Timeline
          </button>
          <button
            onClick={() => {
              trackCustomEvent(TrackingEvents.ClickedToSwitchToVisualChronology);
              onViewModeChange(ViewMode.Visual);
            }}
            className={`flex items-center gap-1 rounded-r px-3 py-2 text-xs font-medium transition-colors duration-200 ${
              viewMode === ViewMode.Visual ? 'bg-blue-500 text-white' : 'bg-white text-gray-600 hover:bg-gray-50'
            }`}
            title="Visualisation View"
          >
            <Waypoints className="h-4 w-4" />
            Visual
          </button>
        </div>
      }
      pagination={
        <Pagination
          canGetPrevPage={canGetPrevPage}
          canGetNextPage={canGetNextPage}
          prevPage={prevPage}
          nextPage={nextPage}
          currentPage={currentPage}
          noOfPages={noOfPages}
          goToPage={goToPage}
        />
      }
    />
  );
};

export default ChronologyTableToolbar;
